import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "../locales/en/common.json";
import pl from "../locales/pl/common.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "pl",
    supportedLngs: ["pl", "en"],
    resources: {
      pl: { common: pl },
      en: { common: en },
    },
    defaultNS: "common",
    interpolation: { escapeValue: false },
  });

export default i18n;
